export default {
  tabMenu: {
    audit: 'Audit',
    auditConfiguration: 'Audit specifications',
    quality: 'Quality',
    qualityConfiguration: 'Quality presets',
    qualityStatistics: 'Quality statistics',
  },
};
